var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 460.63748,
    height: 451.27368,
    viewBox: "0 0 121.87699 119.39948",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-7.546952e-6,-177.60042)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE1F5 \\uE4E6",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4354",
    transform: "matrix(13.842904,0,0,13.842746,-717.3886,-2909.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4360",
    style: {
      strokeWidth: 2.38434362
    },
    d: "M 57.519333,229.48828 C 57.35,229.35069 57.117167,229.26603 56.842,229.26603 c -1.04775,0 -1.883833,0.77258 -1.883833,1.59808 0,0.49742 0.402166,0.79375 0.92075,0.79375 0.846666,0 1.883833,-0.79375 1.894416,-1.5875 v -7.03792 h -0.254 z m 0.20869,-6.45584 v 1.05834 h 2.645834 v 0.51858 h -2.645834 v 1.05833 h 2.645834 v 3.81 c -0.169334,-0.13758 -0.402167,-0.22225 -0.677334,-0.22225 -1.04775,0 -1.883833,0.77259 -1.883833,1.59809 0,0.49741 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.883833,-0.78317 1.894417,-1.5875 v -7.02734 z m -4.772044,2.70187 c 0,-0.30692 -0.254,-0.56092 -0.560916,-0.56092 -0.3175,0 -0.5715,0.254 -0.5715,0.56092 0,0.17991 0.105833,0.33866 0.232833,0.43391 0.07408,0.0529 0.148167,0.0952 0.232833,0.11642 0.0635,0.0106 0.148167,0.0317 0.22225,0.0317 0.116417,0 0.232834,-0.0317 0.328084,-0.0635 0.116416,-0.0317 0.1905,-0.0635 0.306916,-0.127 0.01058,-0.0106 0.03175,-0.0106 0.04233,-0.0106 0.03175,0 0.04233,0.0423 0.04233,0.0847 0,0.0212 0,0.0529 -0.01058,0.0847 -0.02117,0.127 -0.635,1.82033 -0.783167,2.37067 0,0.10583 0.1905,0.11641 0.243417,0.11641 0.09525,0 0.211666,-0.0212 0.296333,-0.0847 0.02117,-0.0212 0.85725,-2.99509 0.85725,-2.99509 0.03175,-0.14816 0.07408,-0.28575 0.08467,-0.32808 0,-0.0847 -0.08467,-0.127 -0.105834,-0.13758 -0.02117,0 -0.04233,0 -0.09525,0.0423 -0.05292,0.0423 -0.47625,0.55033 -0.762,0.55033 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErss);
export default __webpack_public_path__ + "static/media/erss.a987bb0390cb02edf70af5d455d35c5a.svg";
export { ForwardRef as ReactComponent };